export const mockSystemCollections = [
  {
    id: 'system-1',
    name: 'LeetCode Top Interview 150',
    description: 'The most frequently asked interview questions',
    type: 'curated' as const,
    ownerId: 'System',
    ownerEmail: 'system@aiprep.io',
    ownerName: 'AIPrep System',
    problemIds: [],
    tags: ['interview', 'top-picks'],
    isPublic: true,
    stats: {
      totalProblems: 150,
      difficulty: { easy: 50, medium: 75, hard: 25 },
      companies: [],
      patterns: []
    },
    createdAt: new Date(),
    updatedAt: new Date()
  }
];